export const SWIPE_YTD = 'YTD';
export const SWIPE_12M = '12M';
export const SWIPE_24M = '24M';
export const SWIPE_MTD = 'MTD';
export const SUMMARY = 'SUMMARY';
export const DETAIL = 'DETAIL';
export const PERFORMANCE = 'PERFORMANCE';
